import { Card, CardContent, Typography, Grid, Stack, Box, Tooltip, CardMedia, useMediaQuery, Button } from '@mui/material';
import { Book1, Driver, Medal, PlayCircle, Star, TickCircle, UserTick } from 'iconsax-react';
import { useEffect, useState } from 'react';
import useAuth from 'hooks/useAuth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import vidyalayaLogo from '../../assets/images/homepage/certificate.jpg';
import CircularWithPath from 'components/@extended/progress/CircularWithPath';
import { addFavoriteCourse } from 'services/course.service';
import Snackbar from 'utils/Snackbar';
import infoIcon from '../../../assets/images/homepage/info.svg';
import heartIcon from '../../../assets/images/homepage/Heart.svg';
import heartFilledIcon from '../../../assets/images/homepage/HeartFilled.svg';
import NoImage from 'assets/images/homepage/NoCourseImage.jpg';
import NotFound from 'pages/extra-pages/not-found';
import NoData from 'assets/images/img_no_data.png';
import { addToCart } from 'services/order.service';
import { dispatch } from 'store';
import { setCart } from 'store/reducers/cart';
import moment from 'moment';
import CustomLearnerButton from 'components/learner-theme/CustomLearnerButton';
import Loader2 from 'components/Loader2';

const CourseCardTemplate = (props: any) => {
  const { user, organization }: any = useAuth();
  const [listData, setListData] = useState<any>([]);
  // const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const isMedium = useMediaQuery('(min-width: 900px) and (max-width: 1199px)'); // 900px to 1199px
  const isLarge = useMediaQuery('(min-width: 1200px)'); // 1200px and above
  const inCourse = pathname === '/learner/mylearning' ? true : false;
  const inAllCourse = pathname === '/learner/course' ? true : false;
  const inFav = props?.data?.[0]?.favoriteCoursesByUser && props?.data?.[0]?.favoriteCoursesByUser?.length > 0 ? true : false;

  const inRelatedCourse = pathname === '/learner/mylearning/course' ? true : false;
  const inFreeCourse = pathname === '/learner/freeCourses' ? true : false;

  const showProgress = (user?.type === 'faculty' || user?.type === 'admin') ? true : props?.tab === 3 ? false : true;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if ((props?.data?.data ?? props?.data) && Array.isArray((props?.data?.data ?? props?.data))) setLoading(false);
  }, [props.data]);

  useEffect(() => {
    if (props?.isFilterCourses) {
      const filteredCourses = props?.data?.data?.flatMap((items: any) => {
        return items.courses || [];
      });
      // setLoading(false);
      setListData(filteredCourses);
    } else {
      const dashCourses = pathname === '/learner' ? props?.data?.slice(0, isMedium ? 2 : 3) : [];
      setListData(pathname === '/learner' ? dashCourses : props?.data);
      // props?.count !== -1 && setLoading(false);
    }
  }, [props.data, isMedium]);

  const handleLikeClick = (courseId: any) => {
    addFavoriteCourse({
      userId: user?._id,
      organizationId: organization?._id,
      courseId
    })
      .then((res) => {
        if (res?.status === 200 || res?.status === 201) {
          Snackbar(res?.data?.message || 'Action completed successfully!', 'success');

          const updatedListData: any = listData.map((item: any, index: number) => {
            const currentItem = inCourse
              ? inFav
                ? item
                : item?.courseId
              : inRelatedCourse || inAllCourse
              ? item
              : item?.courses?.courseId;

            if (currentItem?._id === courseId) {
              const isUserAlreadyFavorited = (currentItem.favoriteCoursesByUser || []).includes(user._id);

              if (item?.courseId) {
                return {
                  ...item,
                  courseId: {
                    ...item.courseId,
                    favoriteCoursesByUser: isUserAlreadyFavorited
                      ? currentItem.favoriteCoursesByUser.filter((id: any) => id !== user._id)
                      : [...(currentItem.favoriteCoursesByUser || []), user._id]
                  }
                };
              }

              return {
                ...currentItem,
                favoriteCoursesByUser: isUserAlreadyFavorited
                  ? currentItem.favoriteCoursesByUser.filter((id: any) => id !== user._id)
                  : [...(currentItem.favoriteCoursesByUser || []), user._id]
              };
            }
            return item;
          });
          setListData(updatedListData);
          props.handleLiked();
        } else;
      })
      .catch((err) => {
        console.error('Error caught:', err);
        if (err?.response?.status === 403) {
          const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
          Snackbar(errorMessage, 'warning');
        } else {
          const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
          // Snackbar(errorMessage, 'error');
        }
      });
  };

  const checkCourseIsStarted = (startDate: string, endDate: string) => {
    const givenStartDate = new Date(startDate);
    const givenEndDate = new Date(endDate);
    const currentDate = new Date();

    if (currentDate < givenStartDate) {
      Snackbar('Course Is Not Started Yet.', 'warning');
      return false; // Block further execution
    } else if (currentDate > givenEndDate) {
      Snackbar('Course Has Ended.', 'warning');
      return false; // Block further execution
    }

    // If within the start and end date, allow navigation
    return true;
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ mt: inCourse ? 0 : -2, justifyContent: !listData || listData?.length === 0 || loading ? 'center' : 'flex-start' }}
      >
        {loading ? (
          <div>
            <Loader2 />
          </div>
        ) : (<>{listData && listData?.length > 0 ? (
          listData?.map((item: any, index: any) => {
            const currentItem = inCourse
              ? inFav
                ? item
                : item?.courseId
              : inRelatedCourse || inAllCourse || inFreeCourse || user?.type === 'faculty' || user?.type === 'admin'
              ? (item?.courseId ?? item)
              : item?.courses?.courseId;

            const isPresent = props?.userCourses?.some((element: any) => element.courseId?._id === currentItem?._id);
            const isSameCourse = props?.userCourses?.find((element: any) => element.courseId?._id === item?._id);
            const progressItem = (inCourse || user?.type === 'faculty' || user?.type === 'admin') ? item : inAllCourse || inFreeCourse ? isSameCourse : item?.courses;
            return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={inCourse ? 4 : isMedium ? (inRelatedCourse ? 4 : 6) : 4}
                lg={inCourse ? 3 : inRelatedCourse ? 3 : 4}
              >
                <Card
                  sx={{
                    // maxWidth: '350px',
                    height: '320px',
                    borderRadius: '20px',
                    border: '1px solid #D8D8D8',
                    cursor: inRelatedCourse || inFreeCourse ? 'default' : 'pointer',
                    boxShadow: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                  }}
                >
                  {/* Image */}
                  <Box
                    sx={{
                      width: '100%',
                      height: '220px',
                      overflow: 'hidden',
                      borderRadius: '20px',
                      position: 'relative',
                      cursor: inRelatedCourse || inFreeCourse ? 'default' : 'pointer'
                    }}
                  >
                    <CardMedia
                      component="img"
                      onClick={() => {
                        if (!checkCourseIsStarted(currentItem?.startDate, currentItem?.endDate)) return;

                        if (inAllCourse) {
                          navigate('/learner/course/info', {
                            state: { rowData: currentItem._id, createdBy: currentItem?.createdBy?._id }
                          });
                        } else {
                          if (currentItem?.price === 0 || currentItem?.users?.includes(user?._id)) {
                            navigate(user?.type === 'student' ? '/learner/mylearning/course' : '/mylearning/course', {
                              state: { courseId: currentItem?._id, userId: user?._id }
                            });
                          }
                        }
                      }}
                      sx={{
                        width: '100%',
                        height: '220px',
                        objectFit: 'cover'
                      }}
                      // onClick={() => {
                      //   navigate('/learner/mylearning/course', {
                      //     state: { courseId: item?.courses?.courseId?._id, userId: user?._id }
                      //   });
                      // }}
                      // src={vidyalayaLogo}
                      src={
                        currentItem?.image?.path
                          ? process.env.REACT_APP_FILE_URL + currentItem?.image?.path
                          : currentItem?.image?.file
                          ? `data:${currentItem?.image?.mimetype};base64,${currentItem?.image?.file}`
                          : NoImage
                      }
                      alt={currentItem?.name}
                    />
                    <>
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '10px',
                          right: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          zIndex: 1
                        }}
                      >
                        {/* Heart Icon */}
                        {(!inFreeCourse && user?.type === 'student') && (
                          <Box
                            sx={{
                              width: '30px',
                              height: '30px',
                              backgroundColor: '#ffffff',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                              cursor: 'pointer'
                            }}
                          >
                            {currentItem?.favoriteCoursesByUser?.includes(user?._id) ? (
                              <img
                                src={heartFilledIcon}
                                onClick={() => {
                                  handleLikeClick(inFav ? currentItem?._id : currentItem?._id);
                                }}
                                width="20"
                                height="20"
                                style={{ objectFit: 'contain', width: inRelatedCourse ? '70%' : '100%' }}
                              />
                            ) : (
                              <img
                                src={heartIcon}
                                onClick={() => {
                                  handleLikeClick(inFav ? currentItem?._id : currentItem?._id);
                                }}
                                width="20"
                                height="20"
                                style={{ objectFit: 'contain', width: inRelatedCourse ? '70%' : '100%' }}
                              />
                            )}
                            {/*                         
                          <Heart
                            color="#cc4343"
                              ={currentItem?.favoriteCoursesByUser?.includes(user?._id) ? 'Bold' : 'Linear'}
                            onClick={() => {
                              handleLikeClick(inFav ? currentItem?._id : currentItem?._id);
                            }}
                          /> */}
                          </Box>
                        )}

                        {/* Medal Icon */}
                        {(progressItem?.certificateContent?.pdf && user?.type === 'student') && (
                          <Box
                            sx={{
                              width: '30px',
                              height: '30px',
                              backgroundColor: '#ffffff',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                              cursor: 'pointer'
                            }}
                          >
                            <Tooltip title="Certificate">
                              <Medal
                                onClick={() => {
                                  navigate(
                                    `/account/accomplishments/verify/${
                                      item?.courses?.certificateContent?.code || item?.certificateContent?.code
                                    }`
                                  );
                                }}
                              />
                            </Tooltip>
                          </Box>
                        )}
                      </Box>
                    </>
                  </Box>

                  <CardContent sx={{ padding: 0 }}>
                    <Box
                      sx={{
                        // paddingLeft: 2,
                        px: 2,
                        // py: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        // spacing={1.5}
                        sx={{ overflow: 'hidden', mt: 1, mb: inRelatedCourse ? 2 : 0 }}
                      >
                        <Tooltip title={currentItem?.name}>
                          <Typography
                            fontFamily={'poppins'}
                            sx={{
                              // mt: 2,
                              color: '#222222',
                              fontSize: '18px',
                              fontWeight: '600',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                              cursor: inRelatedCourse || inFreeCourse ? 'default' : 'pointer'
                            }}
                            onClick={() => {
                              if (!checkCourseIsStarted(currentItem?.startDate, currentItem?.endDate)) return;

                              if (inAllCourse) {
                                navigate('/learner/course/info', {
                                  state: { rowData: currentItem._id, createdBy: currentItem?.createdBy?._id }
                                });
                              } else {
                                if (currentItem?.price === 0 || currentItem?.users?.includes(user?._id)) {
                                  navigate(user?.type === 'student' ? '/learner/mylearning/course' : '/mylearning/course', {
                                    state: { courseId: currentItem?._id, userId: user?._id }
                                  });
                                }
                              }
                            }}
                          >
                            {currentItem?.name}
                          </Typography>
                        </Tooltip>

                        {user?.type === 'student' && inAllCourse ? (
                          <Stack direction="row" alignItems="center" spacing={1} sx={{ flexShrink: 0 }}>
                            {currentItem?.inCart ? (
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <Typography color={'#063B9A'} sx={{ whiteSpace: 'nowrap' }}>
                                  In-Cart
                                </Typography>
                                <TickCircle variant="Bulk" color="#063B9A" size={'24'} />
                              </Stack>
                            ) : (
                              <Button
                                variant="outlined"
                                size="small"
                                color={currentItem?.paid === 'free' || isPresent ? 'primary' : 'success'}
                                onClick={() => {
                                  if (!checkCourseIsStarted(currentItem?.startDate, currentItem?.endDate)) return;
                                  if (currentItem?.price === 0 || currentItem?.users?.includes(user?._id)) {
                                    navigate(user?.type === 'student' ? (currentItem?.paid === 'free' || isPresent ? '/learner/mylearning/course' : '/learner/course') : '/mylearning/course', {
                                      state:
                                        currentItem?.paid === 'free' || isPresent
                                          ? {
                                              courseId: currentItem?._id,
                                              userId: user?._id,
                                              sectionId: isSameCourse?.inprogressSection,
                                              contentId: isSameCourse?.inprogressContent
                                            }
                                          : {
                                              rowData: currentItem._id,
                                              section: currentItem?.section?.length,
                                              content: currentItem?.contentInfo?.length,
                                              createdBy: currentItem?.createdBy?._id
                                            }
                                    });
                                  }
                                  currentItem?.paid === 'paid' &&
                                    !isPresent &&
                                    !currentItem?.inCart &&
                                    addToCart({
                                      userId: user?._id,
                                      courseId: currentItem?._id,
                                      price: currentItem?.price,
                                      subtotal: currentItem?.price,
                                      totalAmount: currentItem?.price
                                    })
                                      .then((res) => {
                                        if (res.status === 201) {
                                          setListData((prev: any) =>
                                            prev.map((course: any) =>
                                              currentItem?._id === course?._id ? { ...course, inCart: true } : course
                                            )
                                          );
                                          dispatch(setCart(res.data.data));
                                          Snackbar('Course added to cart successfully!!!', 'success');
                                        } else {
                                          Snackbar(res.data.message, 'error');
                                        }
                                      })
                                      .catch((err) => {
                                        if (err?.response?.status === 403) {
                                          const errorMessage =
                                            err?.response?.data?.message ||
                                            "You don't have the required permissions to perform this action.";
                                          Snackbar(errorMessage, 'warning');
                                        } else {
                                          const errorMessage =
                                            err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
                                          Snackbar(errorMessage, 'error');
                                        }
                                      });
                                }}
                                sx={{
                                  transition: 'background-color 0.3s ease',
                                  '&:hover': {
                                    backgroundColor: currentItem?.paid === 'free' || isPresent ? '#063B9A' : '#063B9A',
                                    borderColor: currentItem?.paid === 'free' || isPresent ? '#063B9A' : '#063B9A',
                                    color: 'white',
                                    whiteSpace: 'nowrap'
                                  }
                                }}
                              >
                                {currentItem?.paid === 'free' || isPresent ? 'Watch now' : currentItem?.inCart ? 'In Cart' : 'Buy now'}
                              </Button>
                            )}
                          </Stack>
                        ) : (
                          <></>
                        )}
                      </Stack>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                        sx={{ overflow: 'hidden', mt: 1, mb: inRelatedCourse ? 2 : 0, flexWrap: 'nowrap' }}
                      >
                        <Stack direction="column" spacing={1} sx={{ flex: 1, minWidth: 0 }}>
                          {inAllCourse ? (
                            <Grid container spacing={0} sx={{ marginTop: 1 }} justifyContent="flex-start">
                              <Stack direction={'row'} justifyContent={'space-between'}>
                                <Stack direction={'column'}>
                                  <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Driver size={16} />
                                    &nbsp;{currentItem?.section?.length} Modules
                                  </Typography>
                                  <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                                    <PlayCircle size={16} />
                                    &nbsp;{currentItem?.contentInfo?.length} Lessons
                                  </Typography>
                                </Stack>
                              </Stack>
                              <Link
                                to={user?.type === 'student' ? '/learner/course/info' : '/course/catalog/info'}
                                state={{
                                  rowData: currentItem?._id,
                                  createdBy: currentItem?.createdBy?._id ? currentItem?.createdBy?._id : currentItem?.createdBy,
                                  completedContent: currentItem?.completedContent,
                                  inprogressContent: currentItem?.inprogressContent,
                                  inprogressSection: currentItem?.inprogressSection,
                                  inprogressAssessment: currentItem?.inprogressAssessment,
                                  completeAssessments: currentItem?.completeAssessments
                                }}
                                style={{ textDecoration: 'none', color: 'success', marginLeft: 6, marginTop: 1 }}
                              >
                                <Tooltip title="Course Info">
                                  <img src={infoIcon} width="12" height="12" style={{ objectFit: 'contain' }} />
                                </Tooltip>
                              </Link>
                            </Grid>
                          ) : (
                            <>
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography
                                  fontFamily={'poppins'}
                                  sx={{ color: '#666666', fontSize: { lg: '12px', md: '10px' }, fontWeight: '400', whiteSpace: 'nowrap' }}
                                >
                                  {inCourse || inRelatedCourse || inFreeCourse || user?.type === 'faculty' || user?.type === 'admin' ? currentItem?.section?.length : item?.sectionCount} Section
                                </Typography>

                                {user?.type === 'student' && <Link
                                  to={user?.type === 'student' ? '/learner/course/info' : '/course/catalog/info'}
                                  state={{
                                    rowData: currentItem?._id,
                                    createdBy: currentItem?.createdBy?._id ? currentItem?.createdBy?._id : currentItem?.createdBy,
                                    completedContent: currentItem?.completedContent,
                                    inprogressContent: currentItem?.inprogressContent,
                                    inprogressSection: currentItem?.inprogressSection,
                                    inprogressAssessment: currentItem?.inprogressAssessment,
                                    completeAssessments: currentItem?.completeAssessments
                                  }}
                                  style={{ textDecoration: 'none', color: 'success', marginLeft: 6 }}
                                >
                                  <Tooltip title="Course Info">
                                    <img src={infoIcon} width="12" height="12" style={{ objectFit: 'contain' }} />
                                  </Tooltip>
                                </Link>}
                              </Stack>
                              {props?.value === 0 ? (
                                <Typography
                                  fontFamily={'poppins'}
                                  sx={{ color: '#222222', fontSize: { lg: '12px', md: '10px' }, whiteSpace: 'nowrap' }}
                                >
                                  Starting on:{' '}
                                  {currentItem?.startDate ? (
                                    <span style={{ fontWeight: '600' }}>{moment(currentItem?.startDate).format('ll')}</span>
                                  ) : (
                                    '--'
                                  )}
                                </Typography>
                              ) : (
                                <Typography
                                  fontFamily={'poppins'}
                                  sx={{ color: '#222222', fontSize: { lg: '12px', md: '10px' }, whiteSpace: 'nowrap' }}
                                >
                                  Ending on:{' '}
                                  {currentItem?.endDate ? (
                                    <span style={{ fontWeight: '600' }}>{moment(currentItem?.endDate).format('ll')}</span>
                                  ) : (
                                    '--'
                                  )}
                                </Typography>
                              )}
                            </>
                          )}

                          <Tooltip
                            title={`${
                              inCourse || inRelatedCourse || inFreeCourse
                                ? currentItem?.createdBy?.firstName
                                : item?.createdByInfo?.firstName
                            } ${
                              inCourse || inRelatedCourse || inFreeCourse ? currentItem?.createdBy?.lastName : item?.createdByInfo?.lastName
                            }`}
                          >
                            <Typography
                              fontFamily={'poppins'}
                              sx={{
                                color: '#999999',
                                fontSize: { lg: '12px', md: '10px' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                // cursor: inRelatedCourse || inFreeCourse ? 'default' : 'pointer'
                                cursor: 'default'
                              }}
                              // onClick={() => {
                              //   navigate('/learner/mylearning/course', {
                              //     state: { courseId: currentItem?._id, userId: user?._id }
                              //   });
                              // }}
                            >
                              <span style={{ color: '#222222', whiteSpace: 'nowrap', fontWeight: '400' }}>Assigned ESO:</span>
                              <span
                                style={{
                                  color: '#222222',
                                  fontWeight: '600',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  display: 'inline-block',
                                  maxWidth: '100%'
                                }}
                              >
                                {inCourse || inRelatedCourse || inAllCourse || user?.type === 'faculty' || user?.type === 'admin'
                                  ? currentItem?.createdBy?.firstName
                                  : item?.createdByInfo?.firstName}{' '}
                                {/* {item?.createdByInfo?.firstName} */}
                                <span
                                  style={{
                                    overflow: 'hidden',
                                    // textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    display: 'inline-block',
                                    maxWidth: '120px',
                                    verticalAlign: 'top'
                                  }}
                                >
                                  {/* {item?.createdByInfo?.lastName} */}
                                  {inCourse || inRelatedCourse || inAllCourse || user?.type === 'faculty' || user?.type === 'admin'
                                    ? currentItem?.createdBy?.lastName
                                    : item?.createdByInfo?.lastName}
                                </span>
                              </span>
                            </Typography>
                          </Tooltip>
                        </Stack>

                        {/* <Box
                            sx={{
                              flexShrink: 0,
                              maxWidth: '120px',
                              width: 'fit-content'
                            }}
                          >
                            <CourseProgressBar
                              sx={{ width: 40, height: 40 }}
                              series={currentItem?.progress ? currentItem?.progress : 0}
                              color={index}
                            />
                          </Box> */}

                        {props?.isFilterCourses || inFreeCourse ? (
                          <Stack sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left', direction: 'column' }}>
                            {/* {currentItem?.paid !== 'paid'  && (
                              <Link
                                to={user?.type === 'faculty' ? 'course/info' : '/learner/course/info'}
                                state={{ rowData: currentItem._id, createdBy: currentItem?.createdBy?._id }}
                              >Link
                                <CustomLearnerButton
                                // variant={'contained'}
                                // sx={{ width: { xl: '85px', lg: '70px', sm: '85px' }, height: '35px' }}
                                // sx={{
                                //   backgroundColor: '#063b9a',
                                //   color: '#FFFFFF',
                                //   paddingLeft: '30px',
                                //   paddingRight: '30px',
                                //   fontSize: {
                                //     xs: '12px'
                                //   },
                                //   fontWeight: 700,
                                //   userSelect: 'auto',
                                //   pointerEvents: 'auto'
                                //   // backgroundColor: isEventEnded(event?.end_time) ? '#CCCCCC' : '#13AC9E'
                                // }}
                                //  disabled={event?.meetingId && isStartTimeValid(event?.start_time, event?.end_time)}
                                // onClick={() => {
                                //   navigate('/learner/mylearning/course', {
                                //     state: { courseId: currentItem?._id, userId: user?._id }
                                //   });
                                // }}
                                >
                                  {!props?.isFilterCourses ? 'Join' : 'Start Learning'}
                                </CustomLearnerButton>
                              </Link>
                            )} */}

                            <Box sx={{ py: 1, display: 'flex', justifyContent: 'space-around' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Star variant="Bold" color="#FF9700" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '1rem' }}
                                >
                                  &nbsp;{parseFloat(item?.rating ? item?.rating?.toFixed(2) || 0 : item?.courseAvgRating?.ratingCount || 0)}
                                </Typography>
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 1 }}>|</Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <UserTick size={24} color="#6293FF" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '1rem' }}
                                >
                                  &nbsp;<strong>{item?.courseUserCount ? item?.courseUserCount : item?.userCount}</strong>
                                </Typography>
                              </Box>
                            </Box>
                          </Stack>
                        ) : (
                          (user?.type === 'student' || user?.type === 'faculty' || user?.type === 'admin') &&
                          showProgress && progressItem && (
                            <Box sx={{ flexShrink: 0, maxWidth: '25%', width: 'fit-content' }}>
                              <CircularWithPath
                                showLabel
                                thickness={isLarge ? 4 : 3}
                                size={isLarge ? '50px' : '38px'}
                                pathColor={'#DDE7F3'}
                                value={progressItem?.progress ? progressItem?.progress : 0}
                                variant="determinate"
                                // color="success"
                                sx={{
                                  // fontSize : '14px',
                                  // fontWeight: '700',
                                  color:
                                    progressItem?.progress < 40
                                      ? '#DF1111'
                                      : progressItem?.progress >= 40 && progressItem?.progress <= 70
                                      ? '#DF7811'
                                      : progressItem?.progress > 70
                                      ? '#189E32'
                                      : '#DF1111'
                                }}
                              />
                            </Box>
                          )
                        )}
                      </Stack>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })
        ) : (
          <>
            {(inRelatedCourse || inFreeCourse || inAllCourse) && !loading ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img src={NoData} alt="No Courses" style={{ width: '200px', height: '200px' }} />
                <Typography fontFamily="poppins" variant="h5" sx={{ color: '#202027', fontWeight: '700', mt: 2 }}>
                  No Related Courses found!!
                </Typography>
              </Box>
            ) : !loading && (
              <NotFound icon={Book1} text="Explore Diverse Courses! Add a New Course to learn!" link="/course" />
            )}
          </>
        )}</>)}
        
      </Grid>
    </>
  );
};

export default CourseCardTemplate;
